<template>
  <div>
    <app-collapse accordion>
      <app-collapse-item class="border rounded my-2">
        <template #header>
          <div class="d-flex w-100 justify-content-between align-items-center">
            <h4>
              {{ info.title_ar }}
            </h4>
            <h6 class="mb-0">
              <feather-icon size="15" icon="CalendarIcon" class="mx-1" />
              {{ info.accomplished_at_date }}
            </h6>
          </div>
        </template>
        <b-row>
          <b-col cols="4">
            <img
              :src="info.image"
              alt="events"
              style="width: 100%; height: auto"
            />
          </b-col>
          <b-col cols="3" class="mt-2">
            <div>
              <b-media no-body class="mb-1 b-flex align-items-center">
                <b-media-aside class="mr-1">
                  <b-avatar rounded variant="light-primary" size="34">
                    <feather-icon icon="CalendarIcon" size="18" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <h6 class="mb-0">{{ info.accomplished_at_date }}</h6>
                </b-media-body>
              </b-media>
            </div>

            <b-media no-body class="mb-1 b-flex align-items-center">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="MapPinIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">{{ info.governorate.name_ar }}</h6>
              </b-media-body>
            </b-media>
          </b-col>
          <b-col cols="5" class="">
            <b-card-text>
              <h3 class="mb-1">التفاصيل</h3>
              <p class="mx-1 text-justify">
                {{ info.description_ar }}
              </p>
            </b-card-text>
          </b-col>
          <b-col cols="12">
            <router-link
              :to="{
                name: 'news-details',
                params: { id: info.id },
              }"
            >
              <b-button variant="outline-primary" class="mt-2">
                المزيد من التفاصيل
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BRow,
  BCol,
  BCardText,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
} from "bootstrap-vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { BImg } from "bootstrap-vue";
import "swiper/css/swiper.css";
export default {
  props: {
    info: Object,
  },

  components: {
    AppCollapse,
    AppCollapseItem,
    BButton,
    BRow,
    BCol,
    BCardText,
    Swiper,
    SwiperSlide,
    BImg,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
  },
  data: () => {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      },
    };
  },
};
</script>
